/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { BlurSpinner } from "../../../BlurSpinner";
import { TemplateHeader, Container, CustomLabel, GridGroup, CustomTr, CheckboxContainer } from "../../styles";
import { StylesDatePicker } from "../../../../ui/stylesDatePicker";
import { InputCheckboxContainer, InputText, InputTextArea } from "../../../../ui/inputs";
import { LabSelect } from "../../../course/select";
import { updateRelevoDePerfil, createRelevoDePerfil, getRelevoDePerfilById, relevoDePerfilCategories } from "../../../../services/relevoDePerfilServices";
import { configDatePickerLenguage, convertToTitleCase } from "../../utils";
import { getSubclientsByClientId } from "../../../../services/clientesServices";
import { handleErrors } from "../../../../services/handleErrors";
import useFetcher from "../../../../hooks/useFetcher";
import { formatNumeroDeLegajo } from "../../../course/segmentationClientGropuModal/clientGroupForm";
import CancelFormModal from "../../cancelFormModal";
import { ButtonPrimary } from "../../../../ui/buttons";

// campos para armar las tablas de habilidades
const habilidadesRequeridas = [
  "trabajoEnEquipo",
  "autonomia",
  "flexibilidad",
  "seguridad",
  "integracion",
  "orientacionNegocio",
  "liderazgo",
  "iniciativa",
  "empuje",
  "organizacion",
  "planificacion",
  "comunicacion",
  "orientacionCliente",
];
const idiomas = ["ingles", "aleman", "frances", "portugues", "italiano"];
const herramientas = ["paqueteOffice", "sistemasDeGestion"];
export const createOrUpdateRelevoDePerfil = async (data, id) => {
  if (id) {
    const res = await updateRelevoDePerfil(id, data);
    return res;
  }
  const res = await createRelevoDePerfil(data);
  return res;
};

export default function RelevoDePerfilForm({ clientId, toggle, reloadRelevos, relevoId }) {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const fechaActual = moment().format("YYYY-MM-DD");
  const [subclients, isLoadingSubclients] = useFetcher(getSubclientsByClientId, [clientId]);
  const [categories, isLoadingCategories] = useFetcher(relevoDePerfilCategories, undefined, "relevoDePerfilCategories");
  const [subclientsValues, setSubclientesValues] = useState([]);
  const locale = configDatePickerLenguage();
  const [valuesFromEdit, setValuesFromEdit] = useState("");
  const [fechaValue, setFechaValue] = useState(fechaActual);
  const [fechaIncorporacionEstimadaValue, setFechaIncorporacionEstimadaValue] = useState(fechaActual);
  const [puestoValue, setPuestoValue] = useState(null);
  const [duracionAsignacionValue, setDuracionAsignacionValue] = useState(null);
  const [aEntregarPorValue, setaEntregarPorValue] = useState(null);
  const [modalidadEntrevistaValue, setModalidadEntrevistaValue] = useState(null);

  useEffect(async () => {
    if (relevoId) {
      const { result } = await getRelevoDePerfilById(relevoId);

      const currentValues = {
        ...result,
      };
      setValuesFromEdit(currentValues);
    }
  }, [relevoId]);

  function getFunctionToFilter(filter, selected) {
    if (filter === "subclients") {
      setSubclientesValues(selected);
    }
    if (filter === "puesto") {
      setPuestoValue(selected);
    }
    if (filter === "duracionAsignacion") {
      setDuracionAsignacionValue(selected);
    }
    if (filter === "aEntregarPor") {
      setaEntregarPorValue(selected);
    }
    if (filter === "modalidadEntrevista") {
      setModalidadEntrevistaValue(selected);
    }
  }

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const subClientOptions =
    subclients && subclients.length > 0
      ? subclients
          .map((e) => {
            return { label: `${formatNumeroDeLegajo(e.numeroDeLegajo)}`, value: e.itemId };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const puestoOptions =
    categories && categories.RelevoDePerfilEnum
      ? categories.RelevoDePerfilEnum.puesto.map((e) => {
          return { label: e.text, value: e.id };
        })
      : [];

  const duracionAsignacionOptions =
    categories && categories.RelevoDePerfilEnum
      ? categories.RelevoDePerfilEnum.duracionAsignacion
          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const aEntregarPorOptions =
    categories && categories.RelevoDePerfilEnum
      ? categories.RelevoDePerfilEnum.entregarPor
          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const modalidadEntrevistasOptions =
    categories && categories.RelevoDePerfilEnum
      ? categories.RelevoDePerfilEnum.modalidadEntrevista

          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleDatesChange = (values, type) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");

    if (type === "fecha") {
      setFechaValue(fechaFormateada);
    }
    if (type === "fechaIncorporacionEstimada") {
      setFechaIncorporacionEstimadaValue(fechaFormateada);
    }
  };

  const formik = useFormik({
    initialValues: {
      // TITULO
      clientId,
      subclients: [],
      titulo: "",
      cargo: "",
      // DATOS DE LA SOLICITUD
      fecha: null,
      confidencial: false,
      empresaNombreFantasia: "",
      lugarTrabajo: "",
      direccionEntrevistas: "",
      personaDecisionIncorporacion: "",
      // DATOS DE LA EMPRESA
      razonSocial: "",
      industria: "",
      // DATOS DEL PUESTO
      referenciaNPAE: "",
      nombrePuesto: "",
      puesto: 0,
      cantidadVacantes: 0,
      areaCargoDependencia: "",
      conformacionArea: "",
      duracionAsignacion: 0,
      posibilidadEfectivizacion: false,
      infoAdicionalAsignacion: "",
      fechaIncorporacionEstimada: null,
      personasACargo: false,
      numeroPersonasACargo: 0,
      trabajoHibridoEsquema: "",
      horariosTrabajo: "",
      // DESCRIPCION DE TAREAS A REALIZAR
      descripcionTareas: "",
      // HABILIDADES REQUERIDAS
      trabajoEnEquipo: 0,
      autonomia: 0,
      flexibilidad: 0,
      seguridad: 0,
      integracion: 0,
      orientacionNegocio: 0,
      liderazgo: 0,
      iniciativa: 0,
      empuje: 0,
      organizacion: 0,
      planificacion: 0,
      comunicacion: 0,
      orientacionCliente: 0,
      // ESTUDIOS
      secundario: "",
      universitarios: "",
      posgrado: "",
      mba: "",
      conocimientosEspecificos: "",
      // IDIOMAS
      ingles: 0,
      frances: 0,
      portugues: 0,
      aleman: 0,
      italiano: 0,
      otrosIdiomas: "",
      // HERRAMIENTAS
      paqueteOffice: 0,
      sistemasDeGestion: 0,
      otrosHerramientas: "",
      // ROPA DE TRABAJO Y EPP
      aEntregarPor: 0,
      prendaAdecco: "",
      // EXPERIENCIA
      requiereExperiencia: false,
      tiempoExperiencia: "",
      // ASPECTOS ECONOMICOS
      salarioBruto: "",
      variable: "",
      convenioCategoria: "",
      beneficios: "",
      otrosAspectosEconomicos: "",
      // PROCESO DE ENTREVISTAS
      etapasEntrevistas: "",
      personasEntrevistan: "",
      areaEntrevistas: "",
      modalidadEntrevista: 0,
      coordinaEntrevistaAdecco: false,
      participaEnNombreAdecco: false,
      estudiosPreIngreso: false,
      cualesEstudiosPreIngreso: "",
      realizaConProveedoresAdecco: false,
      instanciasAdicionales: "",
      otrosComentarios: "",
      // FACTURACION
      requiereOCPODED: "",
      remitenteFactura: "",
      // flag
      template: true,
    },

    onSubmit: async (values) => {
      const dataToCreateRelevo = {
        ...values,
        subclients: (subclientsValues && subclientsValues.map((e) => e.value)) || [],
        puesto: (puestoValue && puestoValue.value) || null,
        duracionAsignacion: (duracionAsignacionValue && duracionAsignacionValue.value) || null,
        aEntregarPor: (aEntregarPorValue && aEntregarPorValue.value) || null,
        modalidadEntrevista: (modalidadEntrevistaValue && modalidadEntrevistaValue.value) || null,
        fecha: fechaValue || null,
        fechaIncorporacionEstimada: fechaIncorporacionEstimadaValue || null,
      };

      try {
        if (subclientsValues.length === 0) {
          toast.error("Debes seleccionar al menos un subcliente.");
          return;
        }
        const { message } = await createOrUpdateRelevoDePerfil(dataToCreateRelevo, relevoId);
        toast.success(message);
        toggle();
        reloadRelevos();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      titulo: Yup.string().required("Este campo es requerido."),
      cargo: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (valuesFromEdit) {
      formik.setValues(valuesFromEdit);
      setFechaValue(moment.utc(valuesFromEdit.fecha).format("YYYY-MM-DD"));
      setFechaIncorporacionEstimadaValue(moment.utc(valuesFromEdit.fechaIncorporacionEstimada).format("YYYY-MM-DD"));
      setSubclientesValues(valuesFromEdit.relsRelevoDePerfilSubcliente.map((e) => ({ label: e.numeroDeLegajo, value: e.itemId })));
      if (categories) {
        setPuestoValue(puestoOptions.find((e) => e.value === valuesFromEdit.puesto));
        setDuracionAsignacionValue(duracionAsignacionOptions.find((e) => e.value === valuesFromEdit.duracionAsignacion));
        setaEntregarPorValue(aEntregarPorOptions.find((e) => e.value === valuesFromEdit.aEntregarPor));
        setModalidadEntrevistaValue(modalidadEntrevistasOptions.find((e) => e.value === valuesFromEdit.modalidadEntrevista));
      }
    }
  }, [valuesFromEdit, categories]);

  return (
    <>
      <CancelFormModal toggle={toggle} closeModal={() => setShowCancelModal(false)} isOpen={showCancelModal} />
      <BlurSpinner>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div style={{ fontFamily: "Nunito" }}>
              <div className="d-flex flex-column justify-content-between align-items-start">
                {/* TITULO */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1 ">
                    <TemplateHeader> Título </TemplateHeader>
                  </div>
                  <div>
                    <div className="mb-1">
                      <InputText
                        type="text"
                        id="titulo"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.titulo}
                        maxLength={40}
                        placeholder={formik.errors.titulo && formik.touched.titulo ? formik.errors.titulo : ""}
                        style={formik.errors.titulo && formik.touched.titulo ? { borderBottom: "1px solid red" } : null}
                      />
                    </div>

                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel>Subcliente</CustomLabel>
                        <LabSelect
                          isMulti
                          id="subclients"
                          name="subclients"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={subclientsValues}
                          placeholder="seleccionar"
                          isClearable
                          isLoading={isLoadingSubclients}
                          disabled={isLoadingSubclients || formik.isSubmitting}
                          options={subClientOptions}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Cargo</CustomLabel>
                        <InputText
                          type="text"
                          id="cargo"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cargo}
                          maxLength={40}
                          placeholder={formik.errors.cargo && formik.touched.cargo ? formik.errors.cargo : null}
                          style={formik.errors.cargo && formik.touched.cargo ? { borderBottom: "1px solid red", placeholder: "red" } : null}
                        />
                      </div>
                    </GridGroup>
                  </div>
                </div>

                {/* DATOS DE LA SOLICITUD */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Datos de la solicitud </TemplateHeader>
                  </div>
                  <GridGroup>
                    <GridGroup>
                      <StylesDatePicker className="mb-1">
                        <CustomLabel htmlFor="fecha"> Fecha </CustomLabel>
                        <DatePicker
                          locale={locale}
                          showIcon
                          placeholder="fecha"
                          className="digits date-input"
                          dateFormat="DD-MM-AAAA"
                          onChange={(e) => handleDatesChange(e, "fecha")}
                          value={fechaValue || fechaActual}
                          selected={fechaValue ? new Date(fechaValue).setDate(new Date(fechaValue).getDate() + 1) : null}
                        />
                      </StylesDatePicker>

                      <div className="mb-1">
                        <CustomLabel> Confidencial </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="confidencial"
                              name="confidencial"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.confidencial}
                            />
                            <label htmlFor="confidencial" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>
                    </GridGroup>

                    <div className="mb-1">
                      <CustomLabel htmlFor="empresaNombreFantasia"> Empresa, nombre de fantasía</CustomLabel>
                      <InputText
                        type="text"
                        id="empresaNombreFantasia"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.empresaNombreFantasia}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="lugarTrabajo"> Lugar de trabajo</CustomLabel>
                      <InputText
                        type="text"
                        id="lugarTrabajo"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lugarTrabajo}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="direccionEntrevistas"> Dirección de las entrevistas</CustomLabel>
                      <InputText
                        type="text"
                        id="direccionEntrevistas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.direccionEntrevistas}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="personaDecisionIncorporacion"> Persona que toma la desición de incorporación</CustomLabel>
                      <InputText
                        type="text"
                        id="personaDecisionIncorporacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.personaDecisionIncorporacion}
                        maxLength="100"
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* DATOS DE LA EMPRESA */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Datos de la empresa </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel htmlFor="razonSocial"> Razon social </CustomLabel>
                      <InputText
                        type="text"
                        id="razonSocial"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.razonSocial}
                        maxLength={40}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="industria"> Industria </CustomLabel>
                      <InputText
                        type="text"
                        id="industria"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.industria}
                        maxLength="100"
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* DATOS DEL PUESTO */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Datos del puesto </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel htmlFor="referenciaNPAE"> Referencia NP-PIN </CustomLabel>
                      <InputText
                        type="text"
                        id="referenciaNPAE"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.referenciaNPAE}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="nombrePuesto"> Nombre del puesto </CustomLabel>
                      <InputText
                        type="text"
                        id="nombrePuesto"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.nombrePuesto}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel>Puesto</CustomLabel>
                      <LabSelect
                        id="puesto"
                        name="puesto"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={puestoValue}
                        placeholder="seleccionar"
                        isClearable
                        isLoading={isLoadingCategories}
                        disabled={isLoadingCategories || formik.isSubmitting}
                        options={puestoOptions}
                      />
                    </div>

                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel htmlFor="cantidadVacantes"> Cantidad de vacantes </CustomLabel>
                        <InputText
                          type="number"
                          id="cantidadVacantes"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cantidadVacantes}
                          maxLength="100"
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel> Posibilidad de efectivización </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="posibilidadEfectivizacion"
                              name="posibilidadEfectivizacion"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.posibilidadEfectivizacion}
                            />
                            <label htmlFor="posibilidadEfectivizacion" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>
                    </GridGroup>

                    <div className="mb-1">
                      <CustomLabel htmlFor="areaCargoDependencia"> Área/Cargo de dependencia/Reporte funcional </CustomLabel>
                      <InputText
                        type="text"
                        id="areaCargoDependencia"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.areaCargoDependencia}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="conformacionArea"> Cómo esta conformada el área? </CustomLabel>
                      <InputText
                        type="text"
                        id="conformacionArea"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.conformacionArea}
                        maxLength="100"
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel> Duración de la asignación </CustomLabel>
                      <LabSelect
                        id="duracionAsignacion"
                        name="duracionAsignacion"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={duracionAsignacionValue}
                        placeholder="seleccionar"
                        isClearable
                        isLoading={isLoadingCategories}
                        disabled={isLoadingCategories || formik.isSubmitting}
                        options={duracionAsignacionOptions}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="infoAdicionalAsignacion"> Info adicional asignación </CustomLabel>
                      <InputText
                        type="text"
                        id="infoAdicionalAsignacion"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.infoAdicionalAsignacion}
                        maxLength="100"
                      />
                    </div>

                    <StylesDatePicker className="mb-1">
                      <CustomLabel htmlFor="fechaIncorporacionEstimada"> Fecha de incorporación estimada </CustomLabel>
                      <DatePicker
                        locale={locale}
                        showIcon
                        placeholder="fecha de ingreso"
                        className="digits date-input"
                        dateFormat="DD-MM-AAAA"
                        onChange={(e) => handleDatesChange(e, "fechaIncorporacionEstimada")}
                        value={fechaIncorporacionEstimadaValue || fechaActual}
                        selected={
                          fechaIncorporacionEstimadaValue
                            ? new Date(fechaIncorporacionEstimadaValue).setDate(new Date(fechaIncorporacionEstimadaValue).getDate() + 1)
                            : null
                        }
                      />
                    </StylesDatePicker>

                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel> Personas a cargo </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="personasACargo"
                              name="personasACargo"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.personasACargo}
                            />
                            <label htmlFor="personasACargo" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>

                      <div className="mb-1">
                        <CustomLabel htmlFor="numeroPersonasACargo"> Número de personas a cargo </CustomLabel>
                        <InputText
                          type="number"
                          id="numeroPersonasACargo"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.numeroPersonasACargo}
                          maxLength="100"
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </GridGroup>

                    <div className="mb-1">
                      <CustomLabel htmlFor="trabajoHibridoEsquema"> Trabajo híbrido/esquema </CustomLabel>
                      <InputText
                        type="text"
                        id="trabajoHibridoEsquema"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.trabajoHibridoEsquema}
                        maxLength="100"
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="horariosTrabajo"> Horarios de trabajo </CustomLabel>
                      <InputText
                        type="text"
                        id="horariosTrabajo"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.horariosTrabajo}
                        maxLength="100"
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* DESCRIPCION DE TAREAS A REALIZAR */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Descripción de tareas a realizar </TemplateHeader>
                  </div>
                  <div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="descripcionTareas"> Mencionar entre 3/5 tareas especificas </CustomLabel>
                      <InputTextArea
                        type="text"
                        id="descripcionTareas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.descripcionTareas}
                        maxLength={250}
                      />
                    </div>
                  </div>
                </div>
                {/* HABILIDADES REQUERIDAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Habilidades requeridas </TemplateHeader>
                  </div>

                  <table border="0" style={{ width: "80%", margin: "20px auto" }}>
                    <GridGroup>
                      {habilidadesRequeridas.map((item) => (
                        <CustomTr key={item}>
                          <td style={{ width: "40%" }}>
                            <CustomLabel> {convertToTitleCase(item)} </CustomLabel>
                          </td>
                          <td style={{ display: "flex", width: "60%", justifyContent: "space-around" }}>
                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Bajo`}> Bajo </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Bajo`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 1 ? 0 : 1)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 1}
                                    value={1}
                                  />
                                  <label htmlFor={`${item}Bajo`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Medio`}> Medio </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Medio`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 2 ? 0 : 2)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 2}
                                    value={2}
                                  />
                                  <label htmlFor={`${item}Medio`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Alto`}> Alto </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Alto`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 3 ? 0 : 3)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 3}
                                    value={3}
                                  />
                                  <label htmlFor={`${item}Alto`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>
                          </td>
                        </CustomTr>
                      ))}
                    </GridGroup>
                  </table>
                </div>

                {/* ESUDIOS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Estudios </TemplateHeader>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel htmlFor="secundario"> Secundario </CustomLabel>
                      <InputText
                        type="text"
                        id="secundario"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.secundario}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="universitarios">Universitarios </CustomLabel>
                      <InputText
                        type="text"
                        id="universitarios"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.universitarios}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="posgrado"> Posgrado </CustomLabel>
                      <InputText
                        type="text"
                        id="posgrado"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.posgrado}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="mba"> MBA </CustomLabel>
                      <InputText
                        type="text"
                        id="mba"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mba}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="conocimientosEspecificos"> Conocimientos especificos </CustomLabel>
                      <InputText
                        type="text"
                        id="conocimientosEspecificos"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.conocimientosEspecificos}
                        maxLength={40}
                      />
                    </div>
                  </div>
                </div>

                {/* IDIOMAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Idiomas </TemplateHeader>
                  </div>

                  <table border="0" style={{ width: "90%", margin: "20px auto" }}>
                    <GridGroup>
                      {idiomas.map((item) => (
                        <CustomTr key={item}>
                          <td style={{ width: "20%" }}>
                            <CustomLabel> {convertToTitleCase(item)} </CustomLabel>
                          </td>
                          <td style={{ display: "flex", width: "80%", justifyContent: "space-around" }}>
                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Basico`}> Básico </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Basico`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 1 ? 0 : 1)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 1}
                                    value={1}
                                  />
                                  <label htmlFor={`${item}Basico`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Intermedio`}> Intermedio </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Intermedio`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 2 ? 0 : 2)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 2}
                                    value={2}
                                  />
                                  <label htmlFor={`${item}Intermedio`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Avanzado`}> Avanzado </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Avanzado`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 3 ? 0 : 3)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 3}
                                    value={3}
                                  />
                                  <label htmlFor={`${item}Avanzado`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Bilingue`}> Bilingüe </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Bilingue`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 4 ? 0 : 4)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 4}
                                    value={4}
                                  />
                                  <label htmlFor={`${item}Bilingue`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>
                          </td>
                        </CustomTr>
                      ))}
                    </GridGroup>
                  </table>
                  <div className="mb-1">
                    <CustomLabel htmlFor="otrosIdiomas"> Otros </CustomLabel>
                    <InputText
                      type="text"
                      id="otrosIdiomas"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.otrosIdiomas}
                      maxLength={40}
                    />
                  </div>
                </div>

                {/* HERRAMIENTAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Herramientas </TemplateHeader>
                  </div>

                  <table border="0" style={{ width: "90%", margin: "20px auto" }}>
                    <GridGroup>
                      {herramientas.map((item) => (
                        <CustomTr key={item}>
                          <td style={{ width: "30%" }}>
                            <CustomLabel> {convertToTitleCase(item)} </CustomLabel>
                          </td>
                          <td style={{ display: "flex", width: "70%", justifyContent: "space-around" }}>
                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Basico`}> Básico </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Basico`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 1 ? 0 : 1)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 1}
                                    value={1}
                                  />
                                  <label htmlFor={`${item}Basico`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Intermedio`}> Intermedio </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Intermedio`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 2 ? 0 : 2)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 2}
                                    value={2}
                                  />
                                  <label htmlFor={`${item}Intermedio`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>

                            <CheckboxContainer>
                              <CustomLabel htmlFor={`${item}Avanzado`}> Avanzado </CustomLabel>
                              <InputCheckboxContainer>
                                <div className="checkbox-wrapper-19">
                                  <input
                                    type="checkbox"
                                    id={`${item}Avanzado`}
                                    name={item}
                                    disabled={formik.isSubmitting}
                                    onChange={() => formik.setFieldValue(item, formik.values[item] === 3 ? 0 : 3)}
                                    onBlur={formik.handleBlur}
                                    checked={formik.values[item] === 3}
                                    value={3}
                                  />
                                  <label htmlFor={`${item}Avanzado`} className="check-box" />
                                </div>
                              </InputCheckboxContainer>
                            </CheckboxContainer>
                          </td>
                        </CustomTr>
                      ))}
                    </GridGroup>
                  </table>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <div className="mb-1">
                      <CustomLabel htmlFor="otrosHerramientas"> Otros </CustomLabel>
                      <InputText
                        type="text"
                        id="otrosHerramientas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.otrosHerramientas}
                        maxLength={40}
                      />
                    </div>
                  </div>
                </div>

                {/* ROPA DE TRABAJO Y EPP */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Ropa de trabajo y EPP </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel>A entregar por</CustomLabel>
                      <LabSelect
                        id="aEntregarPor"
                        name="aEntregarPor"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={aEntregarPorValue}
                        placeholder="seleccionar"
                        isClearable
                        isLoading={isLoadingCategories}
                        disabled={isLoadingCategories || formik.isSubmitting}
                        options={aEntregarPorOptions}
                      />
                    </div>
                    <div className="mb-1">
                      <CustomLabel htmlFor="prendaAdecco"> Indicar prenda y caracteristicas de la misma a entregar por Adecco </CustomLabel>
                      <InputText
                        type="text"
                        id="prendaAdecco"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.prendaAdecco}
                        maxLength={300}
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* EXPERIENCIA */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Experiencia </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel> ¿Se requiere experiencia previa en el puesto? </CustomLabel>
                      <InputCheckboxContainer>
                        <div className="checkbox-wrapper-19">
                          <input
                            type="checkbox"
                            id="requiereExperiencia"
                            name="requiereExperiencia"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.requiereExperiencia}
                          />
                          <label htmlFor="requiereExperiencia" className="check-box" />
                        </div>
                      </InputCheckboxContainer>
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="tiempoExperiencia"> ¿Cuánto tiempo? </CustomLabel>
                      <InputText
                        type="text"
                        id="tiempoExperiencia"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tiempoExperiencia}
                        maxLength={40}
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* ASPECTOS ECONOMICOS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Aspectos económicos </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel htmlFor="salarioBruto"> Salario bruto </CustomLabel>
                      <InputText
                        type="text"
                        id="salarioBruto"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.salarioBruto}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="variable"> Variable </CustomLabel>
                      <InputText
                        type="text"
                        id="variable"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.variable}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="convenioCategoria"> Convenio y categoría </CustomLabel>
                      <InputText
                        type="text"
                        id="convenioCategoria"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.convenioCategoria}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="beneficios"> Beneficios </CustomLabel>
                      <InputText
                        type="text"
                        id="beneficios"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.beneficios}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="otrosAspectosEconomicos"> Otros </CustomLabel>
                      <InputText
                        type="text"
                        id="otrosAspectosEconomicos"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.otrosAspectosEconomicos}
                        maxLength={40}
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* PROCESO DE ENTRVISTAS */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Proceso de entrevistas</TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel htmlFor="etapasEntrevistas"> Etapas/Cantidad de instancias </CustomLabel>
                      <InputText
                        type="text"
                        id="etapasEntrevistas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.etapasEntrevistas}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="personasEntrevistan"> Personas que entrevistan </CustomLabel>
                      <InputText
                        type="text"
                        id="personasEntrevistan"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.personasEntrevistan}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="areaEntrevistas"> ¿De qué área? </CustomLabel>
                      <InputText
                        type="text"
                        id="areaEntrevistas"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.areaEntrevistas}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel>Modalidad</CustomLabel>
                      <LabSelect
                        id="modalidadEntrevista"
                        name="modalidadEntrevista"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={modalidadEntrevistaValue}
                        placeholder="seleccionar"
                        isClearable
                        isLoading={isLoadingCategories}
                        disabled={isLoadingCategories || formik.isSubmitting}
                        options={modalidadEntrevistasOptions}
                      />
                    </div>
                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel> ¿Se coordina la entrevista desde Adecco? </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="coordinaEntrevistaAdecco"
                              name="coordinaEntrevistaAdecco"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.coordinaEntrevistaAdecco}
                            />
                            <label htmlFor="coordinaEntrevistaAdecco" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>

                      <div className="mb-1">
                        <CustomLabel> ¿Participamos en nombre de Adecco? </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="participaEnNombreAdecco"
                              name="participaEnNombreAdecco"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.participaEnNombreAdecco}
                            />
                            <label htmlFor="participaEnNombreAdecco" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>
                    </GridGroup>

                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel> ¿Se realizarán estudios pre ingreso? </CustomLabel>
                        <InputCheckboxContainer>
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id="estudiosPreIngreso"
                              name="estudiosPreIngreso"
                              disabled={formik.isSubmitting}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.estudiosPreIngreso}
                            />
                            <label htmlFor="estudiosPreIngreso" className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </div>

                      <div className="mb-1">
                        <CustomLabel htmlFor="cualesEstudiosPreIngreso"> ¿Cuales? </CustomLabel>
                        <InputText
                          type="text"
                          id="cualesEstudiosPreIngreso"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cualesEstudiosPreIngreso}
                          maxLength={300}
                        />
                      </div>
                    </GridGroup>

                    <div className="mb-1">
                      <CustomLabel> ¿Se realizará con proveedores de Adecco? </CustomLabel>
                      <InputCheckboxContainer>
                        <div className="checkbox-wrapper-19">
                          <input
                            type="checkbox"
                            id="realizaConProveedoresAdecco"
                            name="realizaConProveedoresAdecco"
                            disabled={formik.isSubmitting}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.realizaConProveedoresAdecco}
                          />
                          <label htmlFor="realizaConProveedoresAdecco" className="check-box" />
                        </div>
                      </InputCheckboxContainer>
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="instanciasAdicionales"> Instancias adicionales previa incorporación </CustomLabel>
                      <InputText
                        type="text"
                        id="instanciasAdicionales"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.instanciasAdicionales}
                        maxLength={40}
                      />
                    </div>
                  </GridGroup>

                  <div className="mb-1">
                    <CustomLabel htmlFor="otrosComentarios">Otros comentarios</CustomLabel>
                    <InputTextArea
                      type="text"
                      id="otrosComentarios"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.otrosComentarios}
                      maxLength={150}
                    />
                  </div>
                </div>

                {/* FACTURACION */}
                <div className="w-100 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <TemplateHeader> Facturación </TemplateHeader>
                  </div>
                  <GridGroup>
                    <div className="mb-1">
                      <CustomLabel htmlFor="requiereOCPODED"> Requiere OC/PO/DED </CustomLabel>
                      <InputText
                        type="text"
                        id="requiereOCPODED"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.requiereOCPODED}
                        maxLength={40}
                      />
                    </div>

                    <div className="mb-1">
                      <CustomLabel htmlFor="remitenteFactura"> Remitente para entregar factura </CustomLabel>
                      <InputText
                        type="text"
                        id="remitenteFactura"
                        disabled={formik.isSubmitting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.remitenteFactura}
                        maxLength={40}
                      />
                    </div>
                  </GridGroup>
                </div>

                {/* ------- */}
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => setShowCancelModal(true)}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" className="btn" type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
